import { useState, useEffect } from "react";
import luhn from "luhn";

export function useCCValidations(
  ccData,
  isReady = false,
  onSuccess,
  onFailure,
  exclusions = []
) {
  // const onSuccessCallback = useRef();
  // const onFailureCallback = useRef();

  const [errors, setErrors] = useState([]);
  const [finished, setFinished] = useState(false);

  // useEffect(() => {
  //   onSuccessCallback.current = onSuccess;
  // }, [onSuccess]);

  // useEffect(() => {
  //   onFailureCallback.current = onFailure;
  // }, [onFailure]);

  useEffect(() => {
    if (!isReady) return;

    const addError = (err) =>
      setErrors((prevErrors) => [...prevErrors, ...[err]]);

    const { cardType, ccNumber, month, year, cvc, name, zip } = ccData;
    const pureNumber = parseInt(ccNumber.replace(/\s/g, "").trim());
    const firstDigit = parseInt(ccNumber.substr(0, 1));

    // Validate Card Type
    if (!exclusions.includes("card_type")) {
      const validCCShortnames = ["visa", "mastercard", "amex", "discover"];
      if (
        // (cardType &&
        //   !validCCShortnames.includes(cardType?.shortname || null)) ||
        cardType &&
        firstDigit?.length &&
        firstDigit !== cardType.firstDigit
      ) {
        addError("invalid_card_type");
      }
    }

    // Validate Card Number
    if (!exclusions.includes("card_number")) {
      if (!String(pureNumber).length) {
        addError("empty_card_number");
      } else if (
        String(pureNumber).length !== cardType?.cardNumberLength ||
        null ||
        !luhn.validate(pureNumber)
      ) {
        addError("invalid_card_number");
      }
    }

    // Validate Expiration Date
    if (!exclusions.includes("expiration_date")) {
      if (!month?.length && !year?.length) {
        addError("empty_expiration_date");
      } else if (
        parseInt(month) <= 0 ||
        parseInt(month) > 12 ||
        !month.length ||
        !year?.length
      ) {
        addError("invalid_expiration");
      } else if (
        parseInt(new Date().getFullYear().toString().substr(-2)) >
        parseInt(year)
      ) {
        addError("expiration_in_past");
      }
    }

    // Validate CVC
    if (!exclusions.includes("cvc")) {
      if (!cvc?.length) {
        addError(
          cardType.shortname === "amex" ? "empty_cvc_amex" : "empty_cvc"
        );
      } else if (cardType && cvc?.length !== cardType?.cvcLength) {
        addError(
          cardType.shortname === "amex" ? "invalid_cvc_amex" : "invalid_cvc"
        );
      }
    }

    // Validate Name
    if (!exclusions.includes("name")) {
      if (name?.length <= 3) {
        addError("empty_name");
      }
    }

    // Validate Zip Code
    if (!exclusions.includes("zip")) {
      if (!zip?.length) {
        addError("empty_zip");
      } else if (zip.length !== 5) {
        addError("invalid_zip");
      }
    }

    setFinished(true);
  }, [isReady, ccData, exclusions]);

  useEffect(() => {
    if (finished) {
      // if (errors.length && onFailure) onFailureCallback.current(errors);
      // else if (onSuccess) onSuccessCallback.current();
      if (errors.length && onFailure) onFailure(errors);
      else if (onSuccess) onSuccess();
      setErrors([]);
      setFinished(false);
    }
  }, [finished, errors, onFailure, onSuccess]);

  return { errors, isReady };
}
